import {
  CategoryInfo,
  financialAssetOptions,
} from 'src/financial/financial-data/hooks/useFinancialItems';
import AddNewBar, { AddNewAction, AddNewMenuEntry } from 'src/cashflows/components/AddNewBar';

type DropdownCategory = 'ASSET' | 'LIABILITY';

type CreateNewPillProps = {
  onCreateSpending?: () => void;
  onCreateProtection?: () => void;
  onCreateAsset?: (product: string) => void;
  onCreateLiability?: (product: string) => void;
};

// Nested products (e.g. Pension) are abstract categories, not creatable entity
// types — descend into them so the dropdown only ever offers concrete leaf
// products (DefinedContributionPension, etc.) that the create flow can handle.
function getCategoryEntries(category: DropdownCategory): AddNewMenuEntry[] {
  const categoryInfo: CategoryInfo = financialAssetOptions[category];
  return categoryInfo.productsOrder.map(product => {
    const productInfo = categoryInfo.products[product];
    if ('products' in productInfo) {
      return {
        label: productInfo.label,
        items: productInfo.productsOrder.map(leaf => ({
          value: leaf,
          label: productInfo.products[leaf].label,
        })),
      };
    }
    return { value: product, label: productInfo.label };
  });
}

export function CreateNewPill({
  onCreateSpending,
  onCreateProtection,
  onCreateAsset,
  onCreateLiability,
}: CreateNewPillProps) {
  const actions: AddNewAction[] = [
    { label: 'Spending account', onClick: onCreateSpending },
    { label: 'Asset', menu: getCategoryEntries('ASSET'), onSelect: onCreateAsset },
    { label: 'Liability', menu: getCategoryEntries('LIABILITY'), onSelect: onCreateLiability },
    { label: 'Protection policy', onClick: onCreateProtection },
  ];

  return <AddNewBar label="Create new" actions={actions} py={14} wrap="nowrap" />;
}
